module.exports = __webpack_public_path__ + "static/media/Feedback.460a0528.svg";